import React, { useState } from "react";
import ButtonPrimary from "../Button/ButtonPrimary";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

import { addPayment } from "../../services/exchange";
import { paymentMethods } from "../../utils/paymentMethods";
import { WALLET_MINIMUM_AMOUNT } from "../../common/constants";
import { formatNumber } from "../../utils/convertToNumber";
import Loading from "../Loading";
import { toast } from "react-toastify";

const ExchangePayment = () => {
  const { enterprise } = useSelector((state) => state.enterprise);
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  const [paymentMethod, setPaymentMethod] = useState("wallet");

  const navigate = useNavigate();
  const location = useLocation();

  const { req, booking, selectedFlight, segment, company, exchangeSc } =
    location.state;

  const { ModifyPrice, ProductOptions } = selectedFlight;

  function checkWalletBalance() {
    if (
      enterprise?.method !== "postPaid" &&
      (!company ||
        company.wallet >
          (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) +
            ModifyPrice?.TotalPrice)
    ) {
      // show error message
      return true;
    }
  }

  const handleClick = async () => {
    if (ModifyPrice?.CurrencyCode?.value === "ETB") {
      const data = {
        ...req,
        price: ModifyPrice?.TotalPrice + (exchangeSc || 0),
        tax: ModifyPrice?.TotalTaxes || 0,
        penalty: ModifyPrice?.TotalFees || 0,
        payment: paymentMethod || "wallet",
        exchangeSC: exchangeSc || 0,
        exchangeDifference: ModifyPrice?.Base || 0,
        id: booking?._id,
        companyId: company?._id,
        user,
      };

      const res = await addPayment(data, setLoading);

      if (res.ticket?.flight) {
        toast.success("Exchange Successful");
        navigate("/booking");
        return;
      }
    }
  };

  function getSegment(ref) {
    return segment?.find((segment) => segment?.id === ref);
  }

  function getTotalPrice() {
    const result = ModifyPrice?.TotalPrice + (exchangeSc || 0);
    return formatNumber(result);
  }

  if (loading) return <Loading />;

  const renderSidebar = () => {
    return (
      <div className="container flex flex-col px-5 mx-auto space-y-8 w-full shadow sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 sm:p-6 xl:p-8">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="py-1 space-y-3">
            {ProductOptions?.map((product, index) => {
              return product?.Product[0]?.FlightSegment?.map(
                (segment, index) => {
                  const flight = getSegment(segment?.Flight?.FlightRef);

                  return (
                    <div key={index}>
                      <span className="text-lg font-semibold text-neutral-500">
                        <h1> {flight?.carrier}</h1>
                      </span>
                      <span className="text-lg font-semibold text-neutral-500 line-clamp-1">
                        <h1>
                          {flight?.Departure?.location} -{" "}
                          {flight?.Arrival?.location}
                        </h1>
                      </span>
                      <span className="block mt-1 text-base font-medium">
                        {moment(flight?.Departure?.date).format(
                          "MMM DD, YYYY "
                        )}{" "}
                        -{" "}
                        {moment(flight?.Arrival?.date).format("MMM DD, YYYY ")}
                      </span>
                      <span className="block mt-1 text-base font-medium">
                        {flight?.Departure?.time.slice(0, -3)} -{" "}
                        {flight?.Arrival?.time.slice(0, -3)}
                      </span>
                    </div>
                  );
                }
              );
            })}
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold">Fee detail</h3>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Fare Difference</span>
            <span>
              {ModifyPrice?.CurrencyCode?.value} {ModifyPrice?.Base}
            </span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Total Taxes</span>
            <span>
              {ModifyPrice?.CurrencyCode?.value} {ModifyPrice?.TotalTaxes}
            </span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Total Fees</span>
            <span>
              {ModifyPrice?.CurrencyCode?.value} {ModifyPrice?.TotalFees}
            </span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service Charge</span>
            <span>
              {ModifyPrice?.CurrencyCode?.value} {exchangeSc}
            </span>
          </div>

          <div className="border-b border-neutral-200"></div>
          <div className="flex justify-between text-xl font-bold text-black">
            <span>Total Price</span>
            <span>
              {ModifyPrice?.CurrencyCode?.value} {getTotalPrice()}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderMain = () => {
    return (
      <div className="container flex flex-col px-5 mx-auto space-y-8 w-full shadow sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 sm:p-6 xl:p-8">
        <h2 className="text-3xl font-semibold lg:text-4xl">
          Confirm and payment
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

        <div className="">
          {checkWalletBalance() && (
            <button
              onClick={() => {
                setPaymentMethod("wallet");
              }}
              className={`p-8 rounded-lg focus:outline-none mr-10  ${
                paymentMethod === "wallet"
                  ? "bg-neutral-800  text-white  h-36 pt-4"
                  : "text-neutral-6000  border border-gray-800 shadow-xl h-36 pt-4"
              }`}
            >
              <div className="flex flex-col gap-2 items-center">
                <img
                  src={
                    "https://www.kindpng.com/picc/m/580-5809740_white-wallet-logo-png-wallet-icon-ios-transparent.png"
                  }
                  alt=""
                  className="my-2 w-16"
                />
                Wallet
              </div>
            </button>
          )}
          {company && (
            <button
              onClick={() => {
                setPaymentMethod("credit");
              }}
              className={`p-8 rounded-lg focus:outline-none mr-10  ${
                paymentMethod === "credit"
                  ? "bg-neutral-800  text-white  h-36 pt-4"
                  : "text-neutral-6000  border border-gray-800 shadow-xl h-36 pt-4"
              }`}
            >
              <div className="flex flex-col gap-2 items-center">
                <img
                  src={
                    "https://media.istockphoto.com/vectors/safe-payment-logo-template-designs-vector-illustration-vector-id1215256045?k=20&m=1215256045&s=612x612&w=0&h=IQX0a8uPVKSTGfJyWtWv3eXAMk4LTuQSmMtNqv_IBZs="
                  }
                  alt=""
                  className="my-2 w-16"
                />
                Credit
              </div>
            </button>
          )}
        </div>

        <h1 className="text-xl font-semibold">
          Selected Payment Method:{" "}
          <span className="text-main">
            {
              paymentMethods.find((method) => method.name === paymentMethod)
                ?.title
            }
          </span>
        </h1>

        {(paymentMethod === "wallet" || paymentMethod === "credit") && (
          <>
            <div className="space-y-2 lg:hidden row lg:p-0">
              <div className="col-12">
                <ButtonPrimary className="w-full text-black rounded-3xl border-red-500 bg-slate-50 border-1 hover:text-white hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-main focus:ring-opacity-50">
                  Cancel Booking
                </ButtonPrimary>
              </div>
              <div className="col-12">
                <ButtonPrimary
                  onClick={handleClick}
                  className="w-full text-black rounded-3xl border-1 border-main bg-slate-50 hover:text-white hover:bg-main-900 focus:outline-none focus:ring-2 focus:ring-main focus:ring-opacity-50"
                >
                  Confirm and pay
                </ButtonPrimary>
              </div>
            </div>

            <div className="hidden gap-4 justify-between pt-8 lg:flex">
              <div className="w-full">
                <ButtonPrimary className="w-full text-black rounded-3xl border-red-500 bg-slate-50 border-1 hover:text-white hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-main focus:ring-opacity-50">
                  Cancel Booking
                </ButtonPrimary>
              </div>
              <div className="w-full">
                <ButtonPrimary
                  onClick={handleClick}
                  className="w-full text-black rounded-3xl border-1 border-main bg-slate-50 hover:text-white hover:bg-main-900 focus:outline-none focus:ring-2 focus:ring-main focus:ring-opacity-50"
                >
                  Confirm and pay
                </ButtonPrimary>
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div>
      <main className="container flex flex-col-reverse mt-11 mb-24 lg:mb-32 lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10">{renderMain()}</div>
        <div className="flex-grow mb-10 lg:block">{renderSidebar()}</div>
      </main>
    </div>
  );
};

export default ExchangePayment;
